"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/shippingSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ShippingSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-3 col-lg-6 col-md-6" | "col-xl-3 col-lg-6 col-md-6 wow fadeInUp" */
    className: string;
    /** Detected variants: "4s" */
    dataWowDuration?: string;
    /** Detected variants: "shipping-item-thirteen wow fadeInUp" | "shipping-item-thirteen" */
    div0ClassName: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    div0DataWowDuration?: string;
    /** Detected variants: "isax isax-truck-tick" | "isax isax-dollar-circle" | "isax isax-user-tick" | "isax isax-back-square" */
    i0ClassName: string;
    /** Detected variants: "Free Shipping" | "Money Guarantee" | "Online Support" | "Return Policy" */
    h40Text: ReactNode;
    /** Detected variants: "Get free shipping on all orders for a hassle free." | "Experience secure payments with Security." | "Get help anytime with our online support 24/7" | "Shop with hassle-free policy returns 30 days!" */
    p0Text: ReactNode;
    /** Detected variants: "shipping-icon" */
    div0ClassName2?: string;
    /** Detected variants: "content" */
    div1ClassName?: string;
    /** Detected variants: "title" */
    h40ClassName?: string;
};
export type HomeThirteenShippingSectionGeneratedProps = {
    divDiv0Div1H40H4Props?: Partial<ComponentProps<"h4">> | ((item: ShippingSection366sItem) => Partial<ComponentProps<"h4">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "shipping" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/shipping-icon-1.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shipping" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/shipping-icon-2.svg" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    shippingSection366s: ShippingSection366sItem[];
    shippingSection366sItemWrapper?: (item: ShippingSection366sItem, content: ReactNode) => ReactNode;
    shippingSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    shippingSection366sH4Visible?: boolean;
    shippingSection366sH4Renderer?: (item: ShippingSection366sItem, defaultNode: ReactNode) => ReactNode;
    shippingSection366sH4Props?: Partial<ComponentProps<"h4">> | ((item: ShippingSection366sItem) => Partial<ComponentProps<"h4">>);
};

const HomeThirteenShippingSectionGenerated: FC<HomeThirteenShippingSectionGeneratedProps> = ({
    sectionImageWithBasePath0ImageAlt = "shipping",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/shipping-icon-1.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "shipping",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/shipping-icon-2.svg",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div1H40H4Props,
    sectionDiv0Div0ClassName,
    shippingSection366s,
    shippingSection366sItemWrapper,
    shippingSection366sRenderer,
    shippingSection366sH4Visible,
    shippingSection366sH4Renderer,
    shippingSection366sH4Props,
}) => {
    return (
        <section className="shipping-section-thirteen section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        shippingSection366s,
                        (item: ShippingSection366sItem) => (
                            <div className={item.className} key={item.key}>
                                <div className={item.div0ClassName} data-wow-duration={item.div0DataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "shipping-icon"}>
                                        <i className={item.i0ClassName} />
                                    </div>
                                    <div className={item.div1ClassName ?? "content"}>
                                        {renderItemNode(shippingSection366sH4Visible, shippingSection366sH4Renderer, item, (
                                            <h4 className={item.h40ClassName ?? "title"} {...(typeof shippingSection366sH4Props === "function" ? shippingSection366sH4Props(item) : (shippingSection366sH4Props ?? {}))} {...(typeof divDiv0Div1H40H4Props === "function" ? divDiv0Div1H40H4Props(item) : (divDiv0Div1H40H4Props ?? {}))}>{item.h40Text}</h4>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        shippingSection366sItemWrapper,
                        shippingSection366sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-1 d-none d-lg-block" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThirteenShippingSectionGenerated;
